// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildPayload} from '../../shared/services/build-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getPartReturns} from '../repositories';
import {openFile} from '../../../shared/services/open-file';

export const exportToExcel = (facets, language, layout, listId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(facets, 'EXCEL', language, layout, listId);

        try {

            const response = await getPartReturns(payload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/shared/action-creators/export-to-excel.js